module.exports = __webpack_public_path__ + "static/media/smoke.602c5c07.svg";